import { createModuleStore } from '../utils'
const createInitialFilterState = () => {
  return {
    selectedReadZones: [],
    selectedSites: [],
    selectedConfigs: [],
    selectedReaderTypes: [],
  }
}
export const useReadersStore = createModuleStore(
  'readers',
  {
    type: 'RFID Reader',
    pageHeading: 'RFID Readers',
    noHistory: true,
    sortingOn: 'toolbar',
    statusesFilterName: 'statuses',
    uploadOptionsCsv: 'xlsx',
    uri: '/readers',
    serviceUri: '/readers',
    listingModuleName: 'Config',
    listingActivityName: 'View Reader',
    formModuleName: 'Config',
    formActivityName: 'Edit Reader',
    allConfigOptions: [],
    readerToolData: {
      requestUuid: '',
      action: '',
      mac: '',
    },
    allFields: [
      {
        key: 'name',
        title: 'NAME',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'externalId',
        title: 'UUID',
        visible: false,
        sortable: false,
        disabled: false,
      },
      {
        key: 'macAddress',
        title: 'MAC ADDRESS',
        visible: true,
        disabled: false,
        sortable: true,
      },
      {
        key: 'networkAddress',
        title: 'NETWORK ADDRESS',
        visible: true,
        disabled: false,
        sortable: true,
      },
      {
        key: 'networkPort',
        title: 'NETWORK PORT',
        visible: true,
        disabled: false,
        sortable: true,
      },
      {
        key: 'readerType',
        title: 'READER TYPE',
        visible: true,
        disabled: false,
        sortable: true,
      },
      {
        key: 'site',
        title: 'SITE',
        type: 'site',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'config',
        title: 'CONFIG NAME',
        type: 'readerconfig',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'lastSeenTimestamp',
        title: 'LAST SEEN',
        visible: true,
        type: 'datetime',
        sortable: true,
        disabled: false,
      },
      {
        key: 'lastUsedTimestamp',
        title: 'LAST USED',
        visible: true,
        type: 'datetime',
        sortable: true,
        disabled: false,
      },
      {
        key: 'lastSeenAlertTimestamp',
        title: 'LAST SEEN ALERT TIME',
        visible: false,
        type: 'datetime',
        sortable: true,
        disabled: false,
      },
      {
        key: 'lastUsedAlertTimestamp',
        title: 'LAST USAGE ALERT TIME',
        visible: false,
        type: 'datetime',
        sortable: true,
        disabled: false,
      },
      {
        key: 'firmwareVersion',
        title: 'FIRMWARE VERSION',
        visible: false,
        disabled: false,
        sortable: true,
      },
      {
        key: 'status',
        title: 'STATUS',
        visible: false,
        disabled: false,
        sortable: true,
      },
      {
        key: 'createdBy',
        title: 'CREATED BY',
        visible: false,
        disabled: false,
        sortable: true,
      },
      {
        key: 'createdTimestamp',
        title: 'CREATED TIME',
        type: 'datetime',
        visible: false,
        disabled: false,
        sortable: true,
      },
      {
        key: 'lastModifiedBy',
        title: 'LAST MODIFIED BY',
        visible: false,
        disabled: false,
        sortable: true,
      },
      {
        key: 'lastModifiedTimestamp',
        title: 'LAST MODIFIED TIME',
        type: 'datetime',
        visible: false,
        disabled: false,
        sortable: true,
      },
      {
        key: 'readZone',
        title: 'READZONE',
        visible: false,
        disabled: false,
        sortable: false,
      },
      {
        key: 'actions',
        title: 'ACTIONS',
        visible: true,
        disabled: true,
        sortable: false,
      },
    ],
    apiColumnsMapping: {
      alias: ['name'],
      macAddress: ['mac', 'mac address'],
      networkAddress: ['ip Address', 'network address', 'ip'],
      networkPort: ['port', 'network port'],
      numAntennas: ['# antennas', 'number of antennas'],
      readerType: ['type', 'reader type'],
      site: ['site'],
      config: ['config', 'config name'],
      status: ['status'],
    },
  },
  {
    supportedPageFilters: {
      readerType: true,
      selectedSites: {
        type: 'sites',
        multiple: true,
        placeholder: 'Pick one or more sites to filter',
        optionsLabel: 'name',
        submitValueKey: 'externalId',
      },
      selectedReadZones: {
        type: 'readzones',
      },
      selectedReaderTypes: {
        type: 'readerTypes',
      },
    },
    filters: createInitialFilterState(),
    readerRowData: null,
    showAntennasModal: false,
    showReaderToolsLogModal: false,
  },
  {
    copy(item) {
      const obj = {
        readerType: item.readerType,
        site: item.site,
        config: item.config,
        deviceNotSeenAlertMillis: item.deviceNotSeenAlertMillis,
        deviceNotUsedAlertMillis: item.deviceNotUsedAlertMillis,
        deviceNotSeenRetryMillis: item.deviceNotSeenRetryMillis,
        deviceNotUsedRetryMillis: item.deviceNotUsedRetryMillis,
        floorCoordinates: item.floorCoordinates,
      }
      return obj
    },
    resetPageFilters() {
      const store = useReadersStore()
      store.filters = createInitialFilterState()
      store.resetBaseFilters()
    },
    updateFloorCoordinates() {
      const store = useReadersStore()
      store.formData.floorCoordinates.forEach((f) => ({
        floor: store.form.fields
          .find((d) => d.name === 'floorCoordinates')
          .componentProps.optionsData.find((d) => d.value === f),
        x: null,
        y: null,
      }))
    },
  },
  {
    actionBindings: {
      floorCoordinates: 'updateFloorCoordinates',
    },
    fields: [
      {
        id: 'reader_floor_map_coordinates',
        name: 'floorCoordinates',
        label: 'Reader Location Map(s)',
        size: 12,
        component: '',
        visible: false,
        componentProps: {
          multiple: true,
          placeholder: 'Please pick one or more location maps where this reader is located',
          optionsData: [],
        },
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'reader_reader_type',
        name: 'readerType',
        label: 'Reader Type',
        size: 5,
        component: '',
        disabled: false,
        componentProps: {},
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'reader_sites',
        name: 'site',
        label: 'Site',
        size: 6,
        component: 'ArsSmartSelect',
        componentProps: {
          placeholder: 'Pick a site',
          mulitple: false,
          serviceUri: '/sites',
          dxTableName: 'Sites',
          optionsLabel: 'name',
        },
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'reader_config',
        name: 'config',
        label: 'Reader Config',
        size: 13,
        component: 'NSelect',
        visible: false,
        componentProps: { placeholder: 'Pick a config', optionsData: [] },
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'reader_mac_address',
        name: 'macAddress',
        label: 'MAC Address',
        size: 4,
        component: 'NInput',
        componentProps: { placeholder: 'Enter reader MAC address' },
        rules: [
          {
            required: true,
            max: 100,
            trigger: 'blur',
            customValidator: 'macAddress',
          },
          {
            trigger: 'blur',
            remoteValidator: 'isReaderMacAddressUnique',
          },
        ],
      },
      {
        id: 'reader_network_address',
        name: 'networkAddress',
        label: 'Network Address',
        size: 4,
        component: 'NInput',
        componentProps: { placeholder: 'Enter reader network address' },
        rules: [
          {
            required: true,
            max: 100,
            trigger: ['blur', 'input'],
          },
          {
            trigger: 'blur',
            remoteValidator: 'isReaderNetworkAddressUnique',
          },
        ],
      },
      {
        id: 'reader_network_port',
        name: 'networkPort',
        label: 'Network Port',
        size: 4,
        component: 'NInputNumber',
        defaultValue: 5084,
        componentProps: { placeholder: 'Enter port' },
        rules: [
          {
            required: true,
            type: 'number',
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'reader_name',
        name: 'name',
        label: 'Name',
        size: 4,
        component: 'NInput',
        componentProps: { placeholder: 'Enter a name for reader' },
        rules: [
          {
            required: true,
            max: 100,
            trigger: ['blur', 'input'],
          },
          {
            trigger: 'blur',
            remoteValidator: 'isNameUnique',
          },
        ],
      },
      {
        id: 'reader_device_not_seen_alert_millis',
        name: 'deviceNotSeenAlertMillis',
        label: 'Device Inactivity Alert Timeout',
        size: 6,
        component: 'NInput',
        defaultValue: '1000',
        visible: false,
        componentProps: { placeholder: 'Enter timeout in milliseconds.' },
        rules: [
          {
            required: true,
            min: 0,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'reader_device_not_seen_retry_millis',
        name: 'deviceNotSeenRetryMillis',
        label: 'Device Not Seen Retry Timeout',
        size: 6,
        component: 'NInput',
        defaultValue: '1000',
        visible: false,
        componentProps: { placeholder: 'Enter retry timeout in milliseconds.' },
        rules: [
          {
            required: true,
            min: 0,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'reader_device_not_used_alert_millis',
        name: 'deviceNotUsedAlertMillis',
        label: 'Idle Device Alert Timeout',
        size: 6,
        component: 'NInput',
        defaultValue: '1000',
        visible: false,
        componentProps: { placeholder: 'Enter timeout in milliseconds.' },
        rules: [
          {
            required: true,
            min: 0,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'reader_device_not_used_retry_millis',
        name: 'deviceNotUsedRetryMillis',
        label: 'Idle Device Retry Timeout',
        size: 6,
        component: 'NInput',
        defaultValue: '1000',
        visible: false,
        componentProps: { placeholder: 'Enter retry timeout in milliseconds.' },
        rules: [
          {
            required: true,
            min: 0,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'reader_antennas',
        name: 'antennas',
        label: 'Antennas',
        size: 12,
        visible: false,
        component: '',
        componentProps: {},
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
    ],
  }
)
